var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6626 3.64706L14.3762 0.337969C14.159 0.121512 13.8651 0 13.5588 0C13.2524 0 12.9585 0.121512 12.7413 0.337969L1.09038 11.9927L0.0266203 16.5918C-0.0100758 16.7599 -0.00881786 16.9341 0.0303022 17.1017C0.0694222 17.2692 0.145416 17.4259 0.252733 17.5603C0.360049 17.6947 0.495977 17.8034 0.650586 17.8784C0.805195 17.9534 0.97458 17.9929 1.14637 17.9939C1.22641 18.002 1.30707 18.002 1.38711 17.9939L6.02846 16.9283L17.6626 5.28478C17.8787 5.06722 18 4.77281 18 4.46592C18 4.15902 17.8787 3.86461 17.6626 3.64706ZM5.46859 15.9187L1.11837 16.8329L2.10935 12.5592L10.8266 3.86019L14.1858 7.22536L5.46859 15.9187ZM14.936 6.41211L11.5768 3.04694L13.5252 1.10635L16.8284 4.47153L14.936 6.41211Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.36f085d709add4456bb6623a1d44f8aa.svg";
export { ForwardRef as ReactComponent };